import React from "react";
import styled from "styled-components";

interface IProps {
    children: React.ReactNode;
}

const SideNav = styled.nav`
    display: flex;
    width: 100%;
    margin-right: 24px;
    @media (min-width: ${(props) => props.theme.layout.breakpoints.md}) {
        width: 250px;
    }
`;

const ItemList = styled.ul`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const SideMenu = ({ children }: IProps) => (
    <SideNav>
        <ItemList>{children}</ItemList>
    </SideNav>
);

export default SideMenu;
